import '../../sass/form/index.scss';
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import configureStore from '../core/reducers/configureStore';
import installGlobalErrorReporter from '@common/helpers/installGlobalErrorReporter';

installGlobalErrorReporter('transcription-form');
import DictionaryReducer from "../core/reducers/DictionaryReducer";
import OrderReducer from "./redusers/OrderReducer";
import UserReducer from "../core/reducers/UserReducer";
import PageReducer from "./redusers/PageReducer";
import PreloaderReducer from "./redusers/PreloaderReducer";
import SiteReducer from "../core/reducers/SiteReducer";
import Index from "./components/Index";
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {resources} from "../core/i18n/resources";
import CountryReducer from "../core/reducers/CountryReducer";
import ErrorBoundary from "../core/components/ErrorBoundary";

const store = configureStore({
    dictionary: DictionaryReducer,
    order: OrderReducer,
    user: UserReducer,
    page: PageReducer,
    preloader: PreloaderReducer,
    site: SiteReducer,
    country: CountryReducer,
});

window.rootElement = document.getElementById('transcription-form-app');

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: rootElement.dataset.lang,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

render(
    <Provider store={store}>
        <ErrorBoundary>
            <Index />
        </ErrorBoundary>
    </Provider>,
    rootElement
);
